export const sanitizeString = (string: string): string => {
  let sanitizedString = string
  sanitizedString = sanitizedString.replaceAll('&', '&amp;')
  sanitizedString = sanitizedString.replaceAll('<', '&lt;')
  sanitizedString = sanitizedString.replaceAll('>', '&gt;')
  sanitizedString = sanitizedString.replaceAll('"', '&quot;')
  sanitizedString = sanitizedString.replaceAll('\'', '&#39;')
  return sanitizedString
}
